/**
 * [NWF] Download List — "show more" paging (NWF-48)
 *
 * The section renders every entry, already sorted, and this script reveals them in steps.
 * Paging cannot happen in the `{% paginate %}` tag: Shopify slices the metaobject array
 * before the section sees it, so sorting would only ever apply within a single page.
 *
 * Same pattern as nwf-video-list.js, minus the filters: cards carry `is-page-hidden` until
 * revealed, and the button counts down what is left.
 *
 * Progressive enhancement — the markup ships with every entry visible and the button hidden.
 * If this script never runs, the page stays complete; hiding is something it does, not
 * something it undoes.
 */
(function () {
    function DownloadList(list) {
        this.list = list;
        this.perPage = parseInt(list.getAttribute('data-nwf-per-page'), 10);
        this.entries = Array.prototype.slice.call(list.querySelectorAll('.nwf-download-entry'));

        var section = list.closest('.section') || document;
        this.wrap = section.querySelector('.nwf-download-list__load-more-wrap');
        this.button = section.querySelector('.nwf-download-list__load-more');
        this.count = section.querySelector('.nwf-download-list__load-more-count');
    }

    DownloadList.prototype.pending = function () {
        return this.entries.filter(function (entry) {
            return entry.classList.contains('is-page-hidden');
        });
    };

    DownloadList.prototype.revealNext = function () {
        this.pending()
            .slice(0, this.perPage)
            .forEach(function (entry) {
                entry.classList.remove('is-page-hidden');
            });
        this.update();
    };

    DownloadList.prototype.update = function () {
        var remaining = this.pending().length;
        if (this.wrap) {
            this.wrap.classList.toggle('is-visible', remaining > 0);
        }
        if (this.count) {
            this.count.textContent = remaining > 0 ? ' (' + remaining + ')' : '';
        }
    };

    DownloadList.prototype.init = function () {
        if (!this.button || !(this.perPage > 0) || this.entries.length <= this.perPage) {
            return;
        }

        this.entries.forEach(function (entry) {
            entry.classList.add('is-page-hidden');
        });
        this.revealNext();

        var self = this;
        this.button.addEventListener('click', function () {
            var firstNew = self.pending()[0];
            self.revealNext();
            // Keyboard users would otherwise be left on a button that just vanished.
            if (firstNew && !self.pending().length) {
                firstNew.setAttribute('tabindex', '-1');
                firstNew.focus({ preventScroll: true });
            }
        });
    };

    function init(root) {
        (root || document).querySelectorAll('[data-nwf-download-list]').forEach(function (list) {
            if (list.dataset.nwfListReady === 'true') {
                return;
            }
            list.dataset.nwfListReady = 'true';
            new DownloadList(list).init();
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            init(document);
        });
    } else {
        init(document);
    }

    // Re-run when the section is re-rendered in the theme editor.
    document.addEventListener('shopify:section:load', function (event) {
        init(event.target);
    });
})();
